"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var react_router_1 = require("react-router");
var fos_ui_1 = require("@ntet/fos-ui");
var routes_1 = require("../routes");
var NoClient = function () {
    var history = (0, react_router_1.useHistory)();
    return (react_1.default.createElement(StyledContainer, null,
        react_1.default.createElement(StyledIcon, { className: "dds-icons icon" }, "error_outline"),
        react_1.default.createElement(StyledText, null, "This user is not assigned to a client. Please contact support for more information."),
        react_1.default.createElement(fos_ui_1.Button, { onClick: function () { return history.push(routes_1.routes.logout); } }, "Sign Out")));
};
exports.default = NoClient;
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n  margin: 0 auto;\n  margin-top: 20rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n  margin: 0 auto;\n  margin-top: 20rem;\n"])));
var StyledIcon = styled_components_1.default.i(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  font-size: 3rem;\n  color: ", ";\n"], ["\n  font-size: 3rem;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red[600];
});
var StyledText = styled_components_1.default.p(templateObject_3 || (templateObject_3 = (0, tslib_1.__makeTemplateObject)(["\n  font-size: 1.6rem;\n  color: ", ";\n"], ["\n  font-size: 1.6rem;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[800];
});
var templateObject_1, templateObject_2, templateObject_3;
